"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _IntegrationSetup = _interopRequireDefault(require("./IntegrationSetup"));

var _axios = _interopRequireDefault(require("axios"));

var _PanelItems = require("./components/PanelItems");

var _UninstallModal = _interopRequireDefault(require("./components/UninstallModal"));

var _common = require("@insided/shared/utils/common");

var _Tabs = require("./components/zendesk/Tabs");

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _validation = require("@insided/shared/utils/validation");

var _interfaces = require("@insided/deprecated-control/integrations/interfaces");

var _constants = require("@insided/shared/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ZendeskIntegration = /*#__PURE__*/function (_Integration) {
  (0, _inherits2.default)(ZendeskIntegration, _Integration);

  var _super = _createSuper(ZendeskIntegration);

  function ZendeskIntegration(props) {
    var _props$isTicketEscala, _props$isSyncTicketDa, _props$isFederatedSea, _props$isOAuthConnect, _props$apiToken, _props$agentEmail, _props$subdomain, _props$locale, _props$searchableCate, _props$isTicketEscala2, _props$isSyncTicketDa2, _props$isFederatedSea2, _props$isOAuthConnect2, _props$apiToken2, _props$agentEmail2, _props$subdomain2, _props$locale2, _props$searchableCate2;

    var _this;

    (0, _classCallCheck2.default)(this, ZendeskIntegration);
    _this = _super.call(this, props);
    _this.state = {
      isInstalled: !!(props.subdomain && (props.isOAuthConnected || props.apiToken)),
      hasLegacyCredentials: !!(props.apiToken && !props.isOAuthConnected),
      isTicketCreationEnabled: (_props$isTicketEscala = props.isTicketEscalationActive) !== null && _props$isTicketEscala !== void 0 ? _props$isTicketEscala : false,
      isSyncTicketDataActive: (_props$isSyncTicketDa = props.isSyncTicketDataActive) !== null && _props$isSyncTicketDa !== void 0 ? _props$isSyncTicketDa : false,
      isFederatedSearchActive: (_props$isFederatedSea = props.isFederatedSearchActive) !== null && _props$isFederatedSea !== void 0 ? _props$isFederatedSea : false,
      isOAuthConnected: (_props$isOAuthConnect = props.isOAuthConnected) !== null && _props$isOAuthConnect !== void 0 ? _props$isOAuthConnect : false,
      apiToken: (_props$apiToken = props.apiToken) !== null && _props$apiToken !== void 0 ? _props$apiToken : '',
      agentEmail: (_props$agentEmail = props.agentEmail) !== null && _props$agentEmail !== void 0 ? _props$agentEmail : '',
      subdomain: (_props$subdomain = props.subdomain) !== null && _props$subdomain !== void 0 ? _props$subdomain : '',
      showTicketCreationActionButtons: false,
      showSyncTicketDataActionButtons: false,
      showFederatedSearchActionButtons: false,
      federatedSearchSyncInProgress: false,
      isConnecting: false,
      language: (_props$locale = props.locale) !== null && _props$locale !== void 0 ? _props$locale : '',
      categories: (_props$searchableCate = props.searchableCategories) !== null && _props$searchableCate !== void 0 ? _props$searchableCate : [],
      storedState: {
        isTicketCreationEnabled: (_props$isTicketEscala2 = props.isTicketEscalationActive) !== null && _props$isTicketEscala2 !== void 0 ? _props$isTicketEscala2 : false,
        isSyncTicketDataActive: (_props$isSyncTicketDa2 = props.isSyncTicketDataActive) !== null && _props$isSyncTicketDa2 !== void 0 ? _props$isSyncTicketDa2 : false,
        isFederatedSearchActive: (_props$isFederatedSea2 = props.isFederatedSearchActive) !== null && _props$isFederatedSea2 !== void 0 ? _props$isFederatedSea2 : false,
        isOAuthConnected: (_props$isOAuthConnect2 = props.isOAuthConnected) !== null && _props$isOAuthConnect2 !== void 0 ? _props$isOAuthConnect2 : false,
        apiToken: (_props$apiToken2 = props.apiToken) !== null && _props$apiToken2 !== void 0 ? _props$apiToken2 : '',
        agentEmail: (_props$agentEmail2 = props.agentEmail) !== null && _props$agentEmail2 !== void 0 ? _props$agentEmail2 : '',
        subdomain: (_props$subdomain2 = props.subdomain) !== null && _props$subdomain2 !== void 0 ? _props$subdomain2 : '',
        language: (_props$locale2 = props.locale) !== null && _props$locale2 !== void 0 ? _props$locale2 : '',
        categories: (_props$searchableCate2 = props.searchableCategories) !== null && _props$searchableCate2 !== void 0 ? _props$searchableCate2 : []
      },
      activeTab: 0,
      showUnsavedChangesModal: false,
      showUninstallModal: false
    };
    _this.onTicketCreationSettingChanged = _this.onTicketCreationSettingChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetTicketCreationSetting = _this.resetTicketCreationSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveTicketCreationSetting = _this.saveTicketCreationSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSyncTicketDataSettingChanged = _this.onSyncTicketDataSettingChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetSyncTicketDataSetting = _this.resetSyncTicketDataSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveSyncTicketDataSetting = _this.saveSyncTicketDataSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetFederatedSearchSetting = _this.resetFederatedSearchSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveFederatedSearchSetting = _this.saveFederatedSearchSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.onConnect = _this.onConnect.bind((0, _assertThisInitialized2.default)(_this));
    _this.onInstall = _this.onInstall.bind((0, _assertThisInitialized2.default)(_this));
    _this.onUninstall = _this.onUninstall.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetInstallationTab = _this.onResetInstallationTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetIntegrationPanelChanges = _this.resetIntegrationPanelChanges.bind((0, _assertThisInitialized2.default)(_this));
    _this.dismissMessage = _this.dismissMessage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ZendeskIntegration, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var params, installationStatus;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = new URLSearchParams(globalThis.location.search);
                installationStatus = params.get('installationStatus');

                if (installationStatus === 'success') {
                  this.setState({
                    message: 'All set! Zendesk connected.',
                    messageType: 'success'
                  });

                  _publish.default.trackEvent('userevent', {
                    type: 'Zendesk OAuth app installed'
                  });

                  globalThis.history.replaceState({}, '', globalThis.location.pathname);
                } else if (installationStatus === 'failure') {
                  this.setState({
                    message: 'Failed to connect to Zendesk. Please try again.',
                    messageType: 'error'
                  });
                  globalThis.history.replaceState({}, '', globalThis.location.pathname);
                } else if (installationStatus !== null) {
                  globalThis.history.replaceState({}, '', globalThis.location.pathname);
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "checkPanelHasUnsavedChanges",
    value: function checkPanelHasUnsavedChanges() {
      var _this$state = this.state,
          apiToken = _this$state.apiToken,
          agentEmail = _this$state.agentEmail,
          subdomain = _this$state.subdomain,
          isTicketCreationEnabled = _this$state.isTicketCreationEnabled,
          isSyncTicketDataActive = _this$state.isSyncTicketDataActive,
          storedState = _this$state.storedState;
      var hasApiTokenChanged = apiToken !== storedState.apiToken;
      var hasAgentEmailChanged = agentEmail !== storedState.agentEmail;
      var hasSubdomainChanged = subdomain !== storedState.subdomain;
      var hasSyncTicketDataSettingChanged = isSyncTicketDataActive !== storedState.isSyncTicketDataActive;
      var hasTicketCreationSettingChanged = isTicketCreationEnabled !== storedState.isTicketCreationEnabled;
      var hasFederatedSearchSettingChanged = this.checkFederatedSearchPanelHasUnsavedChanges();
      return hasApiTokenChanged || hasAgentEmailChanged || hasSubdomainChanged || hasTicketCreationSettingChanged || hasSyncTicketDataSettingChanged || hasFederatedSearchSettingChanged;
    }
  }, {
    key: "checkFederatedSearchPanelHasUnsavedChanges",
    value: function checkFederatedSearchPanelHasUnsavedChanges() {
      var _this$state2 = this.state,
          isFederatedSearchActive = _this$state2.isFederatedSearchActive,
          categories = _this$state2.categories,
          language = _this$state2.language,
          storedState = _this$state2.storedState;
      var hasCategoriesChanged = JSON.stringify(categories) !== JSON.stringify(storedState.categories);
      var hasLanguageChanged = language !== storedState.language;
      var hasFederatedSearchSettingChanged = isFederatedSearchActive !== storedState.isFederatedSearchActive;
      return hasFederatedSearchSettingChanged || hasCategoriesChanged || hasLanguageChanged;
    }
  }, {
    key: "dismissMessage",
    value: function dismissMessage() {
      this.setState({
        messageType: undefined,
        message: ''
      });
    }
  }, {
    key: "onInstall",
    value: function () {
      var _onInstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this$state3, apiToken, subdomain, agentEmail, validatedFields, data, result, _result$data, savedToken, savedSubdomain, savedEmail, updatedStoredState, _e$response, _e$response$data, errorMessage, isSubdomainError, isCombinationError, errorFields;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.resetMessages();
                _this$state3 = this.state, apiToken = _this$state3.apiToken, subdomain = _this$state3.subdomain, agentEmail = _this$state3.agentEmail;
                validatedFields = [];

                if (apiToken === '') {
                  validatedFields.push({
                    field: 'apiToken',
                    message: 'Please enter an API token.'
                  });
                }

                if (subdomain === '') {
                  validatedFields.push({
                    field: 'subdomain',
                    message: 'Please enter a subdomain.'
                  });
                }

                if (agentEmail === '') {
                  validatedFields.push({
                    field: 'agentEmail',
                    message: 'Please enter an agent email.'
                  });
                }

                if (!(0, _validation.isEmailValid)(agentEmail)) {
                  validatedFields.push({
                    field: 'agentEmail',
                    message: 'Please enter a valid email address.'
                  });
                }

                if (!this.isInputInvalid(validatedFields)) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return");

              case 9:
                data = {
                  apiToken: apiToken,
                  subdomain: subdomain,
                  agentEmail: agentEmail
                };
                _context2.prev = 10;
                _context2.next = 13;
                return _axios.default.post('/integration/zendesk/settings', data);

              case 13:
                result = _context2.sent;
                _result$data = result.data, savedToken = _result$data.apiToken, savedSubdomain = _result$data.subdomain, savedEmail = _result$data.agentEmail;
                updatedStoredState = _objectSpread({}, this.state.storedState);
                updatedStoredState.apiToken = savedToken;
                updatedStoredState.subdomain = savedSubdomain;
                updatedStoredState.agentEmail = savedEmail;
                this.setState({
                  isInstalled: !!(savedToken && savedSubdomain && savedEmail),
                  apiToken: savedToken,
                  subdomain: savedSubdomain,
                  agentEmail: savedEmail,
                  storedState: updatedStoredState,
                  message: 'All set! Zendesk installed.',
                  messageType: 'success',
                  errorFields: [],
                  isSavingCredentials: false
                });

                _publish.default.trackEvent('userevent', {
                  type: 'Zendesk app installed'
                });

                _context2.next = 30;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2["catch"](10);
                errorMessage = (_e$response = _context2.t0.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : _e$response$data.error;
                isSubdomainError = !!(errorMessage !== null && errorMessage !== void 0 && errorMessage.includes('Subdomain is invalid.'));
                isCombinationError = !!(errorMessage !== null && errorMessage !== void 0 && errorMessage.includes('The combination of subdomain, agent email and API token is not valid.'));
                errorFields = [].concat((0, _toConsumableArray2.default)(isSubdomainError ? [{
                  field: 'subdomain',
                  message: "This subdomain doesn't exist, please check again."
                }] : []), (0, _toConsumableArray2.default)(isCombinationError ? [{
                  field: 'apiToken',
                  message: 'The combination of subdomain and agent email is not valid. Please double-check and try again.'
                }, {
                  field: 'agentEmail',
                  message: 'The combination of subdomain and agent email is not valid. Please double-check and try again.'
                }] : []));
                this.setState({
                  errorFields: errorFields,
                  isSavingCredentials: false,
                  message: errorFields.length === 0 ? errorMessage !== null && errorMessage !== void 0 ? errorMessage : 'Something went wrong. Please try again later.' : undefined,
                  messageType: errorFields.length === 0 ? 'error' : undefined
                });

              case 30:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[10, 23]]);
      }));

      function onInstall() {
        return _onInstall.apply(this, arguments);
      }

      return onInstall;
    }()
  }, {
    key: "onConnect",
    value: function () {
      var _onConnect = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var subdomain, validatedFields, _result$data2, result, authorizationUrl, _e$response2, _data$error, _data$error2, _data$error3, data, errorFields;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.resetMessages();
                subdomain = this.state.subdomain;
                validatedFields = [];

                if (subdomain === '') {
                  validatedFields.push({
                    field: 'subdomain',
                    message: 'Please enter a subdomain.'
                  });
                }

                if (!this.isInputInvalid(validatedFields)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return");

              case 6:
                this.setState({
                  isConnecting: true
                });
                _context3.prev = 7;
                _context3.next = 10;
                return _axios.default.post('/integration/zendesk/oauth/initiate', {
                  subdomain: subdomain
                });

              case 10:
                result = _context3.sent;
                authorizationUrl = (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : _result$data2.authorizationUrl;

                if (authorizationUrl) {
                  _context3.next = 14;
                  break;
                }

                throw new Error('Missing authorizationUrl in response');

              case 14:
                globalThis.location.href = authorizationUrl;
                _context3.next = 23;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3["catch"](7);
                data = (_e$response2 = _context3.t0.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.data;
                errorFields = [];

                if (data !== null && data !== void 0 && (_data$error = data.error) !== null && _data$error !== void 0 && _data$error.includes('Subdomain is invalid.') || data !== null && data !== void 0 && (_data$error2 = data.error) !== null && _data$error2 !== void 0 && _data$error2.includes('subdomain')) {
                  errorFields.push({
                    field: 'subdomain',
                    message: "This subdomain doesn't exist, please check again."
                  });
                }

                this.setState({
                  errorFields: errorFields,
                  message: errorFields.length === 0 ? (_data$error3 = data === null || data === void 0 ? void 0 : data.error) !== null && _data$error3 !== void 0 ? _data$error3 : 'Something went wrong. Please try again later.' : undefined,
                  messageType: errorFields.length === 0 ? 'error' : undefined
                });

              case 23:
                _context3.prev = 23;
                this.setState({
                  isConnecting: false
                });
                return _context3.finish(23);

              case 26:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 17, 23, 26]]);
      }));

      function onConnect() {
        return _onConnect.apply(this, arguments);
      }

      return onConnect;
    }()
  }, {
    key: "onResetInstallationTab",
    value: function onResetInstallationTab(activeTab) {
      this.setState({
        apiToken: '',
        agentEmail: '',
        subdomain: '',
        showUnsavedChangesModal: false,
        errorFields: [],
        activeTab: activeTab
      });
    }
  }, {
    key: "onUninstall",
    value: function () {
      var _onUninstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var successMessage, errorMessage, updatedStoredState, _e$response3, _data$error4, data;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });
                successMessage = "You've uninstalled Zendesk.";
                errorMessage = "Something went wrong, credentials can't be uninstalled. Please try again.";
                _context4.prev = 3;
                _context4.next = 6;
                return _axios.default.delete('/integration/zendesk/settings');

              case 6:
                updatedStoredState = _objectSpread({}, this.state.storedState);
                updatedStoredState.isTicketCreationEnabled = false;
                updatedStoredState.isFederatedSearchActive = false;
                updatedStoredState.isSyncTicketDataActive = false;
                updatedStoredState.isOAuthConnected = false;
                updatedStoredState.apiToken = '';
                updatedStoredState.agentEmail = '';
                updatedStoredState.subdomain = '';
                this.setState({
                  isInstalled: false,
                  apiToken: '',
                  agentEmail: '',
                  subdomain: '',
                  isOAuthConnected: false,
                  isTicketCreationEnabled: false,
                  isSyncTicketDataActive: false,
                  isFederatedSearchActive: false,
                  storedState: updatedStoredState,
                  showUninstallModal: false,
                  messageType: 'success',
                  message: successMessage
                });
                _context4.next = 21;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](3);
                data = (_e$response3 = _context4.t0.response) === null || _e$response3 === void 0 ? void 0 : _e$response3.data;
                this.setState({
                  messageType: 'error',
                  message: (_data$error4 = data === null || data === void 0 ? void 0 : data.error) !== null && _data$error4 !== void 0 ? _data$error4 : errorMessage,
                  showUninstallModal: false
                });

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 17]]);
      }));

      function onUninstall() {
        return _onUninstall.apply(this, arguments);
      }

      return onUninstall;
    }()
  }, {
    key: "resetIntegrationPanelChanges",
    value: function resetIntegrationPanelChanges(activeTab) {
      this.setState({
        activePanel: undefined
      });
      var _this$state4 = this.state,
          isTicketCreationEnabled = _this$state4.isTicketCreationEnabled,
          isSyncTicketDataActive = _this$state4.isSyncTicketDataActive,
          storedState = _this$state4.storedState;

      if (isTicketCreationEnabled !== storedState.isTicketCreationEnabled) {
        this.resetTicketCreationSetting();
      }

      if (isSyncTicketDataActive !== storedState.isSyncTicketDataActive) {
        this.resetSyncTicketDataSetting();
      }

      if (this.checkFederatedSearchPanelHasUnsavedChanges()) {
        this.resetFederatedSearchSetting();
      }

      if (this.state.selectedTab !== undefined && this.state.selectedTab !== this.state.activeTab) {
        this.setState({
          activeTab: activeTab
        });
      }
    }
  }, {
    key: "onTicketCreationSettingChanged",
    value: function onTicketCreationSettingChanged(value) {
      this.setState({
        isTicketCreationEnabled: value,
        showTicketCreationActionButtons: true
      });
    }
  }, {
    key: "resetTicketCreationSetting",
    value: function resetTicketCreationSetting() {
      var _this$state5 = this.state,
          storedState = _this$state5.storedState,
          selectedPanel = _this$state5.selectedPanel;
      this.setState({
        isTicketCreationEnabled: storedState.isTicketCreationEnabled,
        showTicketCreationActionButtons: false,
        showUnsavedChangesModal: false,
        activePanel: selectedPanel
      });
    }
  }, {
    key: "saveTicketCreationSetting",
    value: function () {
      var _saveTicketCreationSetting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var successMessage, errorMessage, isTicketCreationEnabled, updatedState;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  isSavingCaseCreationSetting: true
                });
                successMessage = 'Changes are saved successfully.';
                errorMessage = "Something went wrong, setting can't be updated. Please try again.";
                isTicketCreationEnabled = this.state.isTicketCreationEnabled;
                _context5.prev = 4;
                _context5.next = 7;
                return _axios.default.post('/integration/zendesk/toggleTicketEscalation', {
                  isActive: isTicketCreationEnabled
                });

              case 7:
                updatedState = _objectSpread({}, this.state.storedState);
                updatedState.isTicketCreationEnabled = isTicketCreationEnabled;
                this.setState({
                  storedState: updatedState,
                  message: successMessage,
                  messageType: 'success',
                  showTicketCreationActionButtons: false,
                  isSavingCaseCreationSetting: false
                });

                _publish.default.trackEvent('userevent', {
                  type: "Create Zendesk tickets from community posts ".concat(isTicketCreationEnabled ? 'enabled' : 'disabled')
                });

                _context5.next = 16;
                break;

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5["catch"](4);
                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showTicketCreationActionButtons: false,
                  isSavingCaseCreationSetting: false,
                  isTicketCreationEnabled: this.state.storedState.isTicketCreationEnabled
                });

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[4, 13]]);
      }));

      function saveTicketCreationSetting() {
        return _saveTicketCreationSetting.apply(this, arguments);
      }

      return saveTicketCreationSetting;
    }()
  }, {
    key: "onSyncTicketDataSettingChanged",
    value: function onSyncTicketDataSettingChanged(value) {
      this.setState({
        isSyncTicketDataActive: value,
        showSyncTicketDataActionButtons: true
      });
    }
  }, {
    key: "resetSyncTicketDataSetting",
    value: function resetSyncTicketDataSetting() {
      var _this$state6 = this.state,
          storedState = _this$state6.storedState,
          selectedPanel = _this$state6.selectedPanel;
      this.setState({
        isSyncTicketDataActive: storedState.isSyncTicketDataActive,
        showSyncTicketDataActionButtons: false,
        showUnsavedChangesModal: false,
        activePanel: selectedPanel
      });
    }
  }, {
    key: "saveSyncTicketDataSetting",
    value: function () {
      var _saveSyncTicketDataSetting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        var successMessage, errorMessage, isSyncTicketDataActive, updatedState;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  isSavingTicketSyncSetting: true
                });
                successMessage = 'Changes are saved successfully.';
                errorMessage = "Something went wrong, setting can't be updated. Please try again.";
                isSyncTicketDataActive = this.state.isSyncTicketDataActive;
                _context6.prev = 4;
                _context6.next = 7;
                return _axios.default.post('/integration/zendesk/toggleSyncTicketData', {
                  isActive: isSyncTicketDataActive
                });

              case 7:
                updatedState = _objectSpread({}, this.state.storedState);
                updatedState.isSyncTicketDataActive = isSyncTicketDataActive;
                this.setState({
                  storedState: updatedState,
                  message: successMessage,
                  messageType: 'success',
                  showSyncTicketDataActionButtons: false,
                  isSavingTicketSyncSetting: false
                });

                _publish.default.trackEvent('userevent', {
                  type: "Zendesk measure your self-service score ".concat(isSyncTicketDataActive ? 'enabled' : 'disabled')
                });

                _context6.next = 16;
                break;

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](4);
                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showSyncTicketDataActionButtons: false,
                  isSavingTicketSyncSetting: false,
                  isSyncTicketDataActive: this.state.storedState.isSyncTicketDataActive
                });

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[4, 13]]);
      }));

      function saveSyncTicketDataSetting() {
        return _saveSyncTicketDataSetting.apply(this, arguments);
      }

      return saveSyncTicketDataSetting;
    }()
  }, {
    key: "resetFederatedSearchSetting",
    value: function resetFederatedSearchSetting() {
      var _this$state7 = this.state,
          storedState = _this$state7.storedState,
          selectedPanel = _this$state7.selectedPanel;
      this.setState({
        isFederatedSearchActive: storedState.isFederatedSearchActive,
        language: storedState.language,
        categories: storedState.categories,
        showFederatedSearchActionButtons: false,
        showUnsavedChangesModal: false,
        activePanel: selectedPanel
      });
    }
  }, {
    key: "saveFederatedSearchSetting",
    value: function () {
      var _saveFederatedSearchSetting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
        var successMessage, errorMessage, _this$state8, isFederatedSearchActive, language, categories, res, updatedState, _this$state$storedSta, _isFederatedSearchActive, _language, _categories;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  isSavingFederatedSearchSetting: true
                });
                successMessage = 'Changes are saved successfully.';
                errorMessage = "Something went wrong, setting can't be updated. Please try again.";
                _this$state8 = this.state, isFederatedSearchActive = _this$state8.isFederatedSearchActive, language = _this$state8.language, categories = _this$state8.categories;
                _context7.prev = 4;
                _context7.next = 7;
                return _axios.default.post('/integration/zendesk/toggleFederatedSearch', {
                  isActive: isFederatedSearchActive,
                  locale: language,
                  searchableCategories: categories
                });

              case 7:
                res = _context7.sent;
                updatedState = _objectSpread({}, this.state.storedState);
                updatedState.isFederatedSearchActive = isFederatedSearchActive;
                updatedState.language = language;
                updatedState.categories = categories;
                this.setState({
                  federatedSearchSyncInProgress: !!res.data.message,
                  storedState: updatedState,
                  message: successMessage,
                  messageType: 'success',
                  showFederatedSearchActionButtons: false,
                  isSavingFederatedSearchSetting: false
                });

                _publish.default.trackEvent('userevent', {
                  type: "Zendesk federated search ".concat(isFederatedSearchActive ? 'enabled' : 'disabled')
                });

                _context7.next = 20;
                break;

              case 16:
                _context7.prev = 16;
                _context7.t0 = _context7["catch"](4);
                _this$state$storedSta = this.state.storedState, _isFederatedSearchActive = _this$state$storedSta.isFederatedSearchActive, _language = _this$state$storedSta.language, _categories = _this$state$storedSta.categories;
                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showFederatedSearchActionButtons: false,
                  isSavingFederatedSearchSetting: false,
                  isFederatedSearchActive: _isFederatedSearchActive,
                  language: _language,
                  categories: _categories
                });

              case 20:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[4, 16]]);
      }));

      function saveFederatedSearchSetting() {
        return _saveFederatedSearchSetting.apply(this, arguments);
      }

      return saveFederatedSearchSetting;
    }()
  }, {
    key: "enabledIntegrationCount",
    value: function enabledIntegrationCount() {
      var storedState = this.state.storedState;
      var count = 0;

      if (storedState.isTicketCreationEnabled) {
        count++;
      }

      if (storedState.isSyncTicketDataActive) {
        count++;
      }

      if (storedState.isFederatedSearchActive) {
        count++;
      }

      return count;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state9 = this.state,
          isInstalled = _this$state9.isInstalled,
          hasLegacyCredentials = _this$state9.hasLegacyCredentials,
          isTicketCreationEnabled = _this$state9.isTicketCreationEnabled,
          activePanel = _this$state9.activePanel,
          messageType = _this$state9.messageType,
          message = _this$state9.message,
          activeTab = _this$state9.activeTab,
          apiToken = _this$state9.apiToken,
          agentEmail = _this$state9.agentEmail,
          subdomain = _this$state9.subdomain,
          storedState = _this$state9.storedState,
          showTicketCreationActionButtons = _this$state9.showTicketCreationActionButtons,
          showUnsavedChangesModal = _this$state9.showUnsavedChangesModal,
          showUninstallModal = _this$state9.showUninstallModal,
          errorFields = _this$state9.errorFields,
          isSyncTicketDataActive = _this$state9.isSyncTicketDataActive,
          showSyncTicketDataActionButtons = _this$state9.showSyncTicketDataActionButtons,
          isFederatedSearchActive = _this$state9.isFederatedSearchActive,
          language = _this$state9.language,
          categories = _this$state9.categories,
          showFederatedSearchActionButtons = _this$state9.showFederatedSearchActionButtons,
          federatedSearchSyncInProgress = _this$state9.federatedSearchSyncInProgress,
          isSavingCaseCreationSetting = _this$state9.isSavingCaseCreationSetting,
          isSavingFederatedSearchSetting = _this$state9.isSavingFederatedSearchSetting,
          isSavingTicketSyncSetting = _this$state9.isSavingTicketSyncSetting,
          isConnecting = _this$state9.isConnecting,
          isSavingCredentials = _this$state9.isSavingCredentials;
      var panelHasUnsavedChanges = this.checkPanelHasUnsavedChanges();
      var enabledIntegrationCount = this.enabledIntegrationCount();

      var isTicketEscalationEnabled = _common.common.isModuleActive('zendeskTicketEscalation');

      var isFederatedSearchEnabled = _common.common.isModuleActive('zendeskFederatedSearch');

      var isSelfServiceDashboardEnabled = _common.common.isModuleActive('analyticsV2SelfService');

      var isZendeskOAuthEnabled = this.props.isZendeskOAuthEnabled;
      return (0, _preact.h)(_IntegrationSetup.default, {
        headerTitle: "Zendesk",
        appLogoName: "zendesk-l",
        appContainerBackgroundColor: "#03363D",
        dismissMessage: function dismissMessage() {
          return _this2.dismissMessage();
        },
        messageType: messageType,
        message: message,
        installButton: isInstalled ? (0, _preact.h)(_PanelItems.InstallAndUninstallButtons, {
          onClickUninstallButton: function onClickUninstallButton() {
            return _this2.onClickUninstallButton();
          }
        }) : (0, _preact.h)(_Button.default, {
          size: "medium",
          variant: "brand",
          title: "Install now",
          className: "installation__button_cta",
          onClick: function onClick() {
            return _this2.setActiveTab(1);
          }
        }),
        description: (0, _preact.h)(OverviewDescriptionText, null),
        tabTitles: ['Integration', 'Installation'],
        activeTab: activeTab,
        onClickTab: function onClickTab(selectedTab) {
          return _this2.setActiveTab(selectedTab);
        },
        tabContents: [(0, _preact.h)(_Tabs.IntegrationTab, {
          key: "integrationTab",
          activePanel: activePanel,
          isInstalled: isInstalled,
          isTicketCreationEnabled: isTicketCreationEnabled,
          saveTicketCreationSetting: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
            return _regenerator.default.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.next = 2;
                    return _this2.saveTicketCreationSetting();

                  case 2:
                    return _context8.abrupt("return", _context8.sent);

                  case 3:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee8);
          })),
          resetTicketCreationSetting: function resetTicketCreationSetting() {
            return _this2.resetTicketCreationSetting();
          },
          onTicketCreationSettingChanged: function onTicketCreationSettingChanged() {
            return _this2.onTicketCreationSettingChanged(!isTicketCreationEnabled);
          },
          showTicketCreationActionButtons: showTicketCreationActionButtons,
          isSyncTicketDataActive: isSyncTicketDataActive,
          saveSyncTicketDataSetting: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
            return _regenerator.default.wrap(function _callee9$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    _context9.next = 2;
                    return _this2.saveSyncTicketDataSetting();

                  case 2:
                    return _context9.abrupt("return", _context9.sent);

                  case 3:
                  case "end":
                    return _context9.stop();
                }
              }
            }, _callee9);
          })),
          resetSyncTicketDataSetting: function resetSyncTicketDataSetting() {
            return _this2.resetSyncTicketDataSetting();
          },
          onSyncTicketDataSettingChanged: function onSyncTicketDataSettingChanged() {
            return _this2.onSyncTicketDataSettingChanged(!isSyncTicketDataActive);
          },
          showSyncTicketDataActionButtons: showSyncTicketDataActionButtons,
          isFederatedSearchActive: isFederatedSearchActive,
          language: language,
          categories: categories,
          saveFederatedSearchSetting: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
            return _regenerator.default.wrap(function _callee10$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    _context10.next = 2;
                    return _this2.saveFederatedSearchSetting();

                  case 2:
                    return _context10.abrupt("return", _context10.sent);

                  case 3:
                  case "end":
                    return _context10.stop();
                }
              }
            }, _callee10);
          })),
          resetFederatedSearchSetting: function resetFederatedSearchSetting() {
            return _this2.resetFederatedSearchSetting();
          },
          onFederatedSearchSettingChanged: function onFederatedSearchSettingChanged() {
            return _this2.onFederatedSearchSettingChanged(!isFederatedSearchActive);
          },
          onLanguageChanged: function onLanguageChanged(value) {
            return _this2.setState({
              language: value
            });
          },
          onCategoriesChanged: function onCategoriesChanged(value) {
            return _this2.setState({
              categories: value.split(',')
            });
          },
          onLanguageInputClicked: function onLanguageInputClicked() {
            return _this2.setState({
              showFederatedSearchActionButtons: true
            });
          },
          onCategoriesInputClicked: function onCategoriesInputClicked() {
            return _this2.setState({
              showFederatedSearchActionButtons: true
            });
          },
          showFederatedSearchActionButtons: showFederatedSearchActionButtons,
          hasUnsavedChanges: panelHasUnsavedChanges,
          showUnsavedChangesModal: showUnsavedChangesModal,
          displayUnsavedChangedModal: function displayUnsavedChangedModal() {
            return _this2.displayUnsavedChangedModal();
          },
          closeModal: function closeModal() {
            return _this2.closeModal();
          },
          resetChanges: function resetChanges() {
            return _this2.resetIntegrationPanelChanges(1);
          },
          storedState: storedState,
          onClickPanelCallback: function onClickPanelCallback(selectedPanel) {
            return _this2.setActivePanel(selectedPanel);
          },
          isTicketEscalationEnabled: isTicketEscalationEnabled,
          isFederatedSearchEnabled: isFederatedSearchEnabled,
          isSelfServiceDashboardEnabled: isSelfServiceDashboardEnabled,
          federatedSearchSyncInProgress: federatedSearchSyncInProgress,
          isSavingCaseCreationSetting: isSavingCaseCreationSetting,
          isSavingFederatedSearchSetting: isSavingFederatedSearchSetting,
          isSavingTicketSyncSetting: isSavingTicketSyncSetting
        }), (0, _preact.h)(_Tabs.InstallationTab, {
          key: "installationTab",
          subdomain: subdomain,
          isInstalled: isInstalled,
          hasLegacyCredentials: hasLegacyCredentials,
          isZendeskOAuthEnabled: isZendeskOAuthEnabled,
          onConnect: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11() {
            return _regenerator.default.wrap(function _callee11$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    _context11.next = 2;
                    return _this2.onConnect();

                  case 2:
                    return _context11.abrupt("return", _context11.sent);

                  case 3:
                  case "end":
                    return _context11.stop();
                }
              }
            }, _callee11);
          })),
          onSave: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12() {
            return _regenerator.default.wrap(function _callee12$(_context12) {
              while (1) {
                switch (_context12.prev = _context12.next) {
                  case 0:
                    _context12.next = 2;
                    return _this2.onInstall();

                  case 2:
                    return _context12.abrupt("return", _context12.sent);

                  case 3:
                  case "end":
                    return _context12.stop();
                }
              }
            }, _callee12);
          })),
          onCancel: function onCancel() {
            return _this2.onResetInstallationTab(1);
          },
          onSubdomainChangeCallback: function onSubdomainChangeCallback(value) {
            return _this2.setState({
              subdomain: value
            });
          },
          onSubdomainClickCallback: function onSubdomainClickCallback() {
            return _this2.removeValidationErrorFromInputField('subdomain');
          },
          apiToken: apiToken,
          agentEmail: agentEmail,
          onApiTokenChangeCallback: function onApiTokenChangeCallback(value) {
            return _this2.setState({
              apiToken: value
            });
          },
          onApiTokenClickCallback: function onApiTokenClickCallback() {
            return _this2.removeValidationErrorFromInputField('apiToken');
          },
          onAgentEmailChangeCallback: function onAgentEmailChangeCallback(value) {
            return _this2.setState({
              agentEmail: value
            });
          },
          onAgentEmailClickCallback: function onAgentEmailClickCallback() {
            return _this2.removeValidationErrorFromInputField('agentEmail');
          },
          onClickManage: function onClickManage() {
            return _this2.setActiveTab(0);
          },
          onClickUninstall: function onClickUninstall() {
            return _this2.onClickUninstallButton();
          },
          errorFields: errorFields,
          hasUnsavedChanges: panelHasUnsavedChanges,
          showUnsavedChangesModal: showUnsavedChangesModal,
          displayUnsavedChangedModal: function displayUnsavedChangedModal() {
            return _this2.displayUnsavedChangedModal();
          },
          closeModal: function closeModal() {
            return _this2.closeModal();
          },
          resetChanges: function resetChanges() {
            return _this2.onResetInstallationTab(0);
          },
          isConnecting: isConnecting,
          isSavingCredentials: isSavingCredentials
        })],
        uninstallModal: (0, _preact.h)(_UninstallModal.default, {
          headerTitle: "Zendesk",
          onUninstall: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13() {
            return _regenerator.default.wrap(function _callee13$(_context13) {
              while (1) {
                switch (_context13.prev = _context13.next) {
                  case 0:
                    _context13.next = 2;
                    return _this2.onUninstall();

                  case 2:
                    return _context13.abrupt("return", _context13.sent);

                  case 3:
                  case "end":
                    return _context13.stop();
                }
              }
            }, _callee13);
          })),
          showUninstallModal: showUninstallModal,
          closeUninstallModal: function closeUninstallModal() {
            return _this2.closeUninstallModal();
          },
          enabledIntegrationCount: enabledIntegrationCount
        })
      });
    }
  }]);
  return ZendeskIntegration;
}(_interfaces.Integration);

var OverviewDescriptionText = function OverviewDescriptionText() {
  return (0, _preact.h)("div", null, "Zendesk Support helps you track, prioritise, and solve customer support tickets. Zendesk Guide is a self-service destination featuring knowledge base articles and a customer portal.", (0, _preact.h)("div", {
    className: "description-details"
  }, "With Gainsight ", _constants.PLATFORM_BRAND_NAME_POSSESSIVE_FORM, " Zendesk integrations, you can:", ' '), (0, _preact.h)("div", {
    className: "description-details"
  }, (0, _preact.h)("ul", null, (0, _preact.h)("li", null, "Increase self-service by displaying Zendesk Guide articles for end users in the ", _constants.PLATFORM_BRAND_NAME, " search results."), (0, _preact.h)("li", null, "Streamline your support workflow by creating Zendesk Support tickets from community posts on", ' ', _constants.PLATFORM_BRAND_NAME, "."), (0, _preact.h)("li", null, "Measure your self-service score by automatically importing Zendesk Support tickets and comparing the ratio of tickets to views of help content on ", _constants.PLATFORM_BRAND_NAME, "."))));
};

var _default = ZendeskIntegration;
exports.default = _default;